module.exports = __webpack_public_path__ + "static/media/kawasaki-pro-bike.a17f712f.jpg";